



























































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { ILoginUserInfo } from '../../store/dto/LoginUserInfo';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import axios from 'axios';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class AccepterLogin extends ApiAccessBase {
  private userInfo : ILoginUserInfo = {username : '',
   authorities : [],
   isOrderUser : false,
   szkNm : '',
   isFirstLogin : false,
   };

  private getId() {
    // TODO ログアウト時に消されそうなので別のストアが必要かも。。。
    let id = supervisingModule.GET_TENANT_ID;
    if (!id) {
      // クエリストリングからidの取得
      const tempId = this.$route.query.id;
      if (typeof tempId === 'string') {
        id = tempId;
        // ストアに保存
        supervisingModule.setTenantId(id);
      }
    }
    return id;
  }

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'ログイン';
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['accepter_login']);
    const path = Constants.UKETSUKE_URL + '/pre-login/' + this.getId();
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false);
  }

  private login() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    this.formData['tenantId'] = this.getId();
    const path = Constants.UKETSUKE_URL + '/login';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // TODO ユーザ情報のセット
        const tempData : any = this.resultData;
        this.userInfo.username = tempData.username;
        this.userInfo.authorities = tempData.authorities;
        this.userInfo.isOrderUser = tempData.orderUser;
        this.userInfo.szkNm = tempData.szkNm;
        this.userInfo.isFirstLogin = tempData.firstLogin;
        supervisingModule.setUserInfo(this.userInfo);
        applicationFormModule.setType(tempData.traderType);
        // 遷移
        if (tempData.firstLogin) {
          //初回ログイン
          router.push({ name: 'accepterChangePassword' });
        } else {
          router.push({ name: 'accepterMainMenu' });
        }
      }
    });
  }
  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add start
  /**
   * パスワード再設定に移動
   */
  private passwordReconfig() {
    router.push('accepterPasswordReconfigRequest');
  }
  // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add end
}
